import React, { useEffect, useRef, useState, useCallback } from "react";

const DatePicker = ({ onSelect, dateFormat }) => {
  useEffect(() => {
    $(`.${dateFormat}`).datepick({
      onSelect: (dateText) => {
        const parsedDate = new Date(dateText[0]).toISOString();
        onSelect(parsedDate);
      },
      dateFormat,
    });
    return () => {
      $(`.${dateFormat}`).datepick('destroy');
    };
  }, [dateFormat]);

  return <div className={dateFormat} />;
};

function DateDropdown({
  column,
  name,
  placeholder,
  onLearningStartDateChange,
  onLearningEndDateChange,
  onRecentStartDateChange,
  onRecentEndDateChange
}) {
  const [isActive, setIsActive] = useState(false);
  const [activeTab, setActiveTab] = useState("one_tab");
  const containerRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsActive(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleUserClick = () => {
    setIsActive((prev) => !prev);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Render tabs and content based on `name`
  const renderContent = () => {
    if (name === "learning") {
      return (
        <>
          <div data-tab="one_tab" className={`tab_date_data ${activeTab === 'one_tab' ? 'active' : ''}`}>
            <DatePicker
              onSelect={onLearningStartDateChange}
              dateFormat="learningSetDate"
            />
          </div>
          <div data-tab="two_tab" className={`tab_date_data ${activeTab === 'two_tab' ? 'active' : ''}`}>
            <DatePicker
              onSelect={onLearningEndDateChange}
              dateFormat="learningRelativeDate"
            />
          </div>
        </>
      );
    }
    if (name === "recent") {
      return (
        <>
          <div data-tab="one_tab" className={`tab_date_data ${activeTab === 'one_tab' ? 'active' : ''}`}>
            <DatePicker
              onSelect={onRecentStartDateChange}
              dateFormat="recentSetDate"
            />
          </div>
          <div data-tab="two_tab" className={`tab_date_data ${activeTab === 'two_tab' ? 'active' : ''}`}>
            <DatePicker
              onSelect={onRecentEndDateChange}
              dateFormat="recentRelativeDate"
            />
          </div>
        </>
      );
    }
    return null;
  };

  return (
    <div className="item-data-filter" ref={containerRef}>
      <div className="data-filter" onClick={() => handleUserClick()}>
        {/* <div className="icon-data-filter">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
          >
            <path
              d="M14.0716 0.714355C14.4661 0.714355 14.7859 1.03415 14.7859 1.42864L14.7864 2.25708C15.3863 2.35253 15.7747 2.5067 16.1649 2.71535C16.8633 3.08887 17.4114 3.63699 17.7849 4.3354C18.1243 4.96992 18.3195 5.59976 18.3524 7.14226L18.3574 7.14293V12.3632L18.3535 12.7989C18.3244 14.3844 18.1286 15.0222 17.7849 15.6647C17.4114 16.3632 16.8633 16.9113 16.1649 17.2848C15.4665 17.6583 14.7737 17.8572 12.8633 17.8572H8.13711L7.70136 17.8534C6.11583 17.8243 5.47808 17.6284 4.83554 17.2848C4.13713 16.9113 3.58901 16.3632 3.21549 15.6647C2.85692 14.9943 2.65926 14.329 2.64402 12.5867L2.64307 7.63697V7.14293C2.68092 5.59976 2.87615 4.96992 3.21549 4.3354C3.58901 3.63699 4.13713 3.08887 4.83554 2.71535C5.22586 2.50661 5.61441 2.3524 6.21472 2.25697L6.2145 1.42864C6.2145 1.03415 6.53429 0.714355 6.92878 0.714355C7.32327 0.714355 7.64307 1.03415 7.64307 1.42864L7.6424 2.1479C7.79774 2.14459 7.96233 2.14293 8.13711 2.14293H12.8633C13.0384 2.14293 13.2032 2.1446 13.3587 2.14792L13.3574 1.42864C13.3574 1.03415 13.6771 0.714355 14.0716 0.714355ZM16.9281 8.5715H4.07164L4.0723 12.5653L4.07862 12.9716C4.10639 14.0482 4.22014 14.5141 4.47523 14.991C4.7156 15.4405 5.05979 15.7847 5.50925 16.0251C6.04234 16.3102 6.5616 16.4187 7.935 16.428H13.0654L13.4717 16.4217C14.5483 16.3939 15.0142 16.2801 15.4912 16.0251C15.9406 15.7847 16.2848 15.4405 16.5252 14.991C16.8103 14.4579 16.9188 13.9387 16.9281 12.5653L16.9281 8.5715ZM14.1045 12.1429C14.4136 12.1429 14.657 12.2009 14.8607 12.3099C15.0644 12.4188 15.2243 12.5787 15.3333 12.7824C15.4422 12.9861 15.5002 13.2295 15.5002 13.5386V13.6044C15.5002 13.9135 15.4422 14.1569 15.3333 14.3606C15.2243 14.5643 15.0644 14.7242 14.8607 14.8331C14.657 14.9421 14.4136 15.0001 14.1045 15.0001H14.0388C13.7296 15.0001 13.4862 14.9421 13.2825 14.8331C13.0788 14.7242 12.919 14.5643 12.81 14.3606C12.7011 14.1569 12.6431 13.9135 12.6431 13.6044V13.5386C12.6431 13.2295 12.7011 12.9861 12.81 12.7824C12.919 12.5787 13.0788 12.4188 13.2825 12.3099C13.4862 12.2009 13.7296 12.1429 14.0388 12.1429H14.1045ZM13.0654 3.57216H7.935L7.64307 3.57578V4.28578C7.64307 4.68027 7.32327 5.00007 6.92878 5.00007C6.53429 5.00007 6.2145 4.68027 6.2145 4.28578L6.21396 3.70901C5.94204 3.7718 5.7268 3.85874 5.50925 3.97509C5.05979 4.21546 4.7156 4.55966 4.47523 5.00911C4.21135 5.50251 4.09872 5.98407 4.07605 7.14196L16.9238 7.14293L16.9218 7.02854C16.894 5.95199 16.7803 5.48608 16.5252 5.00911C16.2848 4.55966 15.9406 4.21546 15.4912 3.97509C15.2737 3.85877 15.0585 3.77184 14.7867 3.70905L14.7859 4.28578C14.7859 4.68027 14.4661 5.00007 14.0716 5.00007C13.6771 5.00007 13.3574 4.68027 13.3574 4.28578L13.359 3.57593C13.2657 3.5741 13.1679 3.57285 13.0654 3.57216Z"
              fill="currentColor"
            />
          </svg>
        </div> */}
        <div className="content-data-filter">{placeholder}</div>
        <div className="arrow-data-filter">
          <div className="data-filter-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M5.46967 8.46967C5.76256 8.17678 6.23744 8.17678 6.53033 8.46967L12 13.9393L17.4697 8.46967C17.7626 8.17678 18.2374 8.17678 18.5303 8.46967C18.8232 8.76256 18.8232 9.23744 18.5303 9.53033L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967Z" fill="currentColor"/>
            </svg>
          </div>
        </div>
      </div>
      <div
        className={`dropdown-data-filter dropdown-date-filter ${isActive ? "active" : ""
          }`}
      >
        <div className="dropdown-tab-date-filter">
          <div className="item-dropdown-tab-date">
            <button
              type="button"
              className={`button-dropdown-tab-date ${activeTab === "one_tab" ? "active" : ""}`}
              data-tab="one_tab"
              onClick={() => handleTabChange("one_tab")}
            >
              Start Date
            </button>
          </div>
          <div className="item-dropdown-tab-date">
            <button
              type="button"
              className={`button-dropdown-tab-date ${activeTab === "two_tab" ? "active" : ""}`}
              data-tab="two_tab"
              onClick={() => handleTabChange("two_tab")}
            >
              End Date
            </button>
          </div>
        </div>
        <div className="dropdown-tab-data-wrapper">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default DateDropdown;
